@if (rosterJobCondition === "requireAcceptance") {
  <div
    class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3 roster-shift-content"
    [style.padding-bottom]="'150px'"
  >
    @for (job of jobListData; track job; let i = $index) {
      <!-- Date Header -->
      @if (
        i === 0 ||
        (jobListData[i - 1].event_date | misc: "eventDateGrouping") !==
          (job?.event_date | misc: "eventDateGrouping")
      ) {
        <div class="col-12 col-md-12 col-lg-12 col-xl-12">
          <div class="p-2 fw-semibold border-bottom position-sticky top-0 z-1">
            {{ job?.event_date | misc: "eventDateGrouping" }}
          </div>
        </div>
      }
      <div class="col">
        <ng-template
          *ngTemplateOutlet="jobDetailTemplate; context: { job: job }"
        ></ng-template>
      </div>
    }
  </div>

  @if (jobListData?.length > 1) {
    <div
      class="position-fixed bottom-0 end-0 d-flex text-end flex-column p-3 bg-secondary-subtle rounded z-1 shadow small text-dark"
    >
      <div class="d-flex gap-3 justify-content-center flex-column">
        <div class="text-primary">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="selectedShiftIds?.length === jobListData?.length"
            (change)="selectAllShifts($event)"
            id="selectAllBox"
          />
          <label for="selectAllBox" class="m-1 text-dark small">
            Select All [{{ selectedShiftIds?.length }}]</label
          >
        </div>
        <div class="d-block">
          <button
            class="btn w-100 btn-success justify-content-center d-flex"
            (click)="onJobActionClick('accept')"
            [disabled]="selectedShiftIds?.length < 2"
          >
            <i class="fa-solid fa-check fs-4"></i>
          </button>
        </div>
        <div class="d-block">
          <button
            class="btn w-100 btn-danger justify-content-center d-flex"
            (click)="openTemplate(jobDeclineTemplateRef)"
            [disabled]="selectedShiftIds?.length < 2"
          >
            <i class="fa-solid fa-xmark fs-4"></i>
          </button>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="fs-5 mb-2 fw-semibold">
    {{
      rosterJobCondition === "unAssignedJobs"
        ? "Unassigned"
        : rosterJobCondition == "pendingShifts"
          ? "Pending Shifts"
          : "Stale Jobs"
    }}
    @if (rosterJobCondition !== "unAssignedJobs") {
      <span
        class="btn btn-sm btn-outline-secondary ms-2 mb-2"
        (click)="
          showAllData = !showAllData; clearValues(); getConditionalShifts()
        "
      >
        {{ showAllData ? "Reset" : "Show All" }}
      </span>
    }
  </div>
  @if (!showAllData) {
    <div class="d-lg-flex gap-2 d-block">
      <div
        class="d-flex gap-1 flex-wrap justify-content-center justify-content-lg-start mb-2 mb-lg-0"
      >
        <div>
          <div
            class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-3 form-control justify-content-center fw-semibold"
            role="button"
          >
            <span
              >{{ selectedDate | customDate: "d MMM y" }} -
              {{ selectedWeekEnd | customDate: "d MMM y" }}</span
            >
            <span><i class="fa-solid fa-calendar ms-1"></i></span>

            <input
              class="hidden-calendar-lookup"
              type="date"
              [(ngModel)]="selectedDate"
              (change)="onSelectedDateChange()"
            />
          </div>
          <!-- <div class="form-floating">
        <input
          class="form-control"
          type="date"
          placeholder="Pick Date"
          [(ngModel)]="selectedDate"
          (change)="onSelectedDateChange()"
        />
        <label>Pick Date</label>
      </div> -->
        </div>

        <div
          (click)="changeWeek('-')"
          class="border rounded p-2 d-flex align-items-center text-secondary"
          role="button"
        >
          <i class="fa-solid fa-caret-left fs-3"></i>
        </div>
        <div
          (click)="changeWeek('+')"
          class="border rounded p-2 d-flex align-items-center text-secondary"
          role="button"
        >
          <i class="fa-solid fa-caret-right fs-3"></i>
        </div>
      </div>
      @if (currentMonday != selectedDate && largeView) {
        <div
          class="d-flex gap-1 flex-wrap justify-content-center justify-content-lg-start"
        >
          <div
            class="border rounded py-lg-2 px-lg-5 d-flex align-items-center text-secondary gap-2 px-5 py-2 small text-uppercase fw-semibold justify-content-center"
            (click)="changeWeek('today')"
            role="button"
          >
            Today
          </div>
        </div>
      }
    </div>
  }

  <gtapp-gt-custom-table
    [deskTopTableData]="jobListData"
    [desktopTableDetails]="jobDetailsTableView"
    [otherParams]="otherParamsCondtionalRosterShifts"
    (rowClick)="openIndividualJob($event)"
    (sortColumn)="sortColumnUser($event)"
    (searchColumn)="searchColumnUser($event)"
    (paginationChange)="onChangePaginationUser($event)"
    [tableStyle]="{ 'overflow': 'auto', 'max-height': 'calc(100vh - 200px)' }"
  >
  </gtapp-gt-custom-table>
}

<ng-template #jobDetailTemplate let-job="job">
  <div class="scheduled-item bg-secondary-subtle text-black">
    <div
      class="d-flex justify-content-between my-2 align-items-center"
      (click)="jobListData?.length > 1 ? selectUnSelectJob(job) : null"
    >
      @if (jobListData?.length > 1) {
        <div class="form-floating">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="selectedShiftIds?.includes(job?.job_uuid)"
          />
        </div>
      }
      <div class="fw-bold">
        {{ job?.shift_info?.start_time }} -
        {{ job?.shift_info?.end_time }}
      </div>
      <div>
        {{ job?.shift_info | misc: "getTimeDifference" }}
        Hrs
      </div>
    </div>

    <div class="fw-semibold my-1">
      {{ job?.job_type_dict?.name | titlecase }}
      @if (job?.service_type_dict?.name) {
        <span class="fw-normal">
          -
          {{ job?.service_type_dict?.name }}
        </span>
      }
    </div>
    <div>
      {{ job?.site_name }}
      @if (job?.company_name) {
        <span>[{{ job?.company_name }}]</span>
      }
    </div>
    @if (job?.site_address) {
      <div class="text-secondary small-font">
        {{ job?.site_address }}
      </div>
    }
    @if (job?.requires_acceptance) {
      <div class="row row-cols-3 my-2 row-gap-3">
        <div class="col">
          @if (selectedShiftIds?.length < 2) {
            <button
              class="btn btn-md btn-success w-100"
              (click)="
                selectedShiftIds = [job?.job_uuid]; onJobActionClick('accept')
              "
            >
              Accept
            </button>
          }
        </div>
        <div class="col">
          @if (selectedShiftIds?.length < 2) {
            <button
              class="btn btn-md btn-danger w-100"
              (click)="
                selectedShiftIds = [job?.job_uuid];
                openTemplate(jobDeclineTemplateRef)
              "
            >
              Decline
            </button>
          }
        </div>
        <div class="col">
          <button
            (click)="openEventDetailPage(job)"
            class="btn btn-md btn-outline-primary w-100"
          >
            Details
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template
  #jobDeclineTemplateRef
  let-data
  let-jobDeclineTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Decline Shift
      <span class="float-end" (click)="jobDeclineTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!-- Request Detail Section start-->
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        placeholder="Decline Reason [160 chars]"
        cols="20"
        rows="4"
        wrap="hard"
        maxlength="160"
        type="text"
        [(ngModel)]="declineReason"
        id="declineReasonField"
      ></textarea>
      @if (declineReason) {
        <span
          class="input-group-text"
          (click)="
            declineReason = ''; clearAndFocusTextBox('declineReasonField')
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <div class="row row-cols-2">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="jobDeclineTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="!declineReason"
          (click)="onJobActionClick('decline'); jobDeclineTemplateRef.close()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>
